module.exports = __webpack_public_path__ + "media/Team/Ryan-9ceada7c.jpeg";